module.exports = __webpack_public_path__ + "img/UTANTE-8.3ae985b4.jpg";